import { Link } from 'react-router-dom';
import React, { useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import managerapi from '../api/managerapi';
import loginapi from '../api/login';
import { FaPlusCircle } from "react-icons/fa";

import { APISERVERURL } from '../APIServerURL';
import Course from '../components/BillCard';

function ViewAllGSTBillsManager({accessToken,setAccessToken, setRefreshFailed,currentMonth,setCurrentMonth,currentYear,setCurrentYear}) {
  const { billType } = useParams();
  const navigate = useNavigate();
  const [registrationForms,setRegistrationForms]=useState([]);
  const [formListLoaded,setFormListLoaded]=useState(false);

  const handleAddNewForm=async()=>{
    //alert('ok');
    setFormListLoaded(false);
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await managerapi.post('/createANewBill',{billType,currentMonth,currentYear},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      setRegistrationForms(response.data.registrationForms);
      setFormListLoaded(true);
      //alert(JSON.stringify(response.data));
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await managerapi.post('/createANewBill',{billType,currentMonth,currentYear},{headers:{'Authorization':`Bearer ${nat}`}});   
                      setRegistrationForms(response.data.registrationForms);
                      setFormListLoaded(true);
                      //alert(JSON.stringify(response.data));
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
            setFormListLoaded(true);
          }
  }
 

  const loadForms=async (currentMonth,currentYear)=>{
    setFormListLoaded(false);
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await managerapi.post('/getBillsByManagerId',{billType:billType,currentMonth,currentYear},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      setRegistrationForms(response.data.registrationForms);
      setFormListLoaded(true);
      //alert(JSON.stringify(response.data));
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await managerapi.post('/getBillsByManagerId',{billType:billType,currentMonth,currentYear},{headers:{'Authorization':`Bearer ${nat}`}});   
                      setRegistrationForms(response.data.registrationForms);
                      setFormListLoaded(true);
                      //alert(JSON.stringify(response.data));
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
            setFormListLoaded(true);
          }
  }

  useEffect(() => {
      if (currentMonth && currentYear) {
        loadForms(currentMonth,currentYear);
      }
    }, [currentMonth, currentYear]);
 
  return (
    <main className="w-full">
     <div className="flex flex-col items-center w-full">


     <div className="w-full bg-red-100 relative py-1">
  {/* Heading */}
  {billType === "GSTBILLS" && (
    <h1 className="text-2xl text-gray-400 text-center">GST BILLS</h1>
  )}
  {billType === "RETAILBILLS" && (
    <h1 className="text-2xl text-gray-400 text-center">RETAIL BILLS</h1>
  )}
  {billType === "CASHMEMOBILLS" && (
    <h1 className="text-2xl text-gray-400 text-center">CASHMEMO BILLS</h1>
  )}
</div>

<div className='w-full bg-red-100 flex flex-col sm:flex-row gap-2 justify-center items-center py-2'>
<div className="flex flex-col items-center">
  <label htmlFor="month" className="text-sm text-gray-600">Select Month</label>
  <select
    id="month"
    value={currentMonth}
    onChange={(e) => {
      if (currentYear !== "ALL") {
        setCurrentMonth(e.target.value);
      }
    }}
    disabled={currentYear === "ALL"}
    className="px-3 py-1 rounded border border-gray-300 disabled:bg-gray-100 disabled:text-gray-500"
  >
    {[
      { value: '01', label: 'January' },
      { value: '02', label: 'February' },
      { value: '03', label: 'March' },
      { value: '04', label: 'April' },
      { value: '05', label: 'May' },
      { value: '06', label: 'June' },
      { value: '07', label: 'July' },
      { value: '08', label: 'August' },
      { value: '09', label: 'September' },
      { value: '10', label: 'October' },
      { value: '11', label: 'November' },
      { value: '12', label: 'December' },
      { value: 'ALL', label: 'All Months' },
    ].map(({ value, label }) => (
      <option key={value} value={value}>{label}</option>
    ))}
  </select>
</div>


  <div className="flex flex-col items-center">
  <label htmlFor="year" className="text-sm text-gray-600">Select Year</label>
  <select
    id="year"
    value={currentYear}
    onChange={(e) => {
      const selectedYear = e.target.value;
      setCurrentYear(selectedYear);
      if (selectedYear === "ALL") {
        setCurrentMonth("ALL");
      }
    }}
    className="px-3 py-1 rounded border border-gray-300"
  >
    {Array.from({ length: 11 }, (_, i) => 2024 + i).map((year) => (
      <option key={year} value={year}>{year}</option>
    ))}
    <option value="ALL">ALL YEARS</option>
  </select>
</div>

</div>


          <div className="w-full flex justify-end bg-gray-100 relative p-1 mt-1">            
            <button
              onClick={handleAddNewForm}
              disabled={!formListLoaded}
              className={`flex items-center gap-2 px-2 py-2 text-white text-xs rounded-lg shadow-md transition duration-300
                ${formListLoaded ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-400 cursor-not-allowed"}`}
            >
              <FaPlusCircle className="w-5 h-5" />
              ADD BILL
            </button>
          </div>
        
        
          {formListLoaded && (
            <div className="w-full  mt-2 py-1 flex flex-wrap gap-4 justify-center items-center min-h-[150px]">
              {registrationForms.length > 0 ? (
                registrationForms.map((form) => <Course key={form._id} form={form} />)
              ) : (
                <p className="text-gray-600 text-sm">No bills to display. Click "Add Bill" to add a new form.</p>
              )}
            </div>
          )}

          
     </div>
    {
   (!formListLoaded) && <div className="w-[98%] max-w-[1200px]">
    Please wait!
    </div>
    }
    </main>
  );
  }
  
  export default ViewAllGSTBillsManager